/**
 * 上下文类型
 */
export enum ModelContextType {
    /** 文本 */
    Text = 'text',
    /** 选中的文本 */
    SelectionText = 'selectionText',
    /**
     * 专利 pn 号
     * 后端接口期望 value 为 patent_id, 所以 label 是 PN 号，value 是 patent_id
     *
     * @deprecated 仅用于 @ 添加专利时使用，使用 PatentID 代替
     */
    PN = 'PN',
    /** 专利 id */
    PatentID = 'PatentID',
    /**
     * 专利列表
     *
     * @deprecated 使用 PatentQuery 代替
     */
    PatentList = 'PatentIdList',
    /**
     * 专利查询条件
     * value 为 JSON 对象字符串，示例：
     * 类型参考: {@link ../proxy/context-proxy.ts#PatentQueryContext}
     * {
     *     "type": "workspace",
     *     "sort": "pdesc",
     *     "comment": true,
     *     "mode": "INCLUDE", // INCLUDE 包含，EXCLUDE 排除，也有可能时全选或者范围选择
     *     "count": 3,
     *     "workspace_id": "111",
     *     "folder_id": "222",
     *     "patent_ids": ["333", "444", "555"]
     * }
     */
    PatentQuery = 'PatentQuery',
    /** 占位符 */
    Placeholder = 'placeholder',

    /** 图片 */
    Image = 'image',

    /** dashboard bi chart */
    Chart = 'biChart',
}

export enum PatentListSourceType {
    SRP = 'srp',
    Workspace = 'workspace',
}

/**
 * extra page中支持的component
 */
export enum ExtraPageName {
    AiPatentBatchResult = 'ai-patent-batch-result',
    PatentList = 'patent-list',
}
